import { ExternalLink } from '@uikit';

import { GENERAL_URLS } from '@shared/constants/urls';

export const publicPool = [
  {
    id: 'accessibility',
    item: (
      <span className="font-normal">
        Accessibility: <span className="font-semibold">Open to all users.</span>
      </span>
    ),
  },
  {
    id: 'mechanism',
    item: (
      <span className="font-normal">
        Mechanism:{' '}
        <span className="font-semibold">Operates on a first-come, first-served basis.</span>
      </span>
    ),
  },
  {
    id: 'participants',
    item: (
      <span className="font-normal">
        Allocation Size:{' '}
        <span className="font-semibold">Participants can contribute between $1 to $5 USDT. </span>
      </span>
    ),
  },
];

export const whitelistPool = [
  {
    id: 'eligibility',
    item: (
      <span className="font-normal">
        Eligibility:{' '}
        <span className="font-semibold">
          Reserved exclusively for Magic Square Members (Plus, Premium, Premium Plus).
        </span>
      </span>
    ),
  },
  {
    id: 'requirements',
    item: (
      <span className="font-normal">
        Requirements:{' '}
        <span className="font-semibold">
          Participants must be whitelisted, which could involve having a certain amount of Karma
          points, SQR staked, or completing specific Magic Square Campaigns in future IDOs. In this
          case, just to be a Magic Square Member.
        </span>
      </span>
    ),
  },
  {
    id: 'pool',
    item: (
      <span className="font-normal">
        Pool Size: <span className="font-semibold">The total pool is $10,000 USDT.</span>
      </span>
    ),
  },
  {
    id: 'allocation',
    item: (
      <span className="font-normal">
        Allocation Size:{' '}
        <span className="font-semibold">
          {' '}
          Each participant can contribute between $1 to $15 USDT.
        </span>
      </span>
    ),
  },
];

export const sqrpPool = [
  {
    id: 'participation',
    item: (
      <span className="font-normal">
        Participation:{' '}
        <span className="font-semibold">
          Open to anyone, but requires depositing both USDT and SQRp points in a 1:1 ratio.
        </span>
      </span>
    ),
  },
  {
    id: 'option1',
    content: 'How to Acquire SQRp:',
    item: [
      {
        id: '',
        subItem: (
          <span className="font-semibold">
            Option 1: Stake SQR tokens at{' '}
            <ExternalLink
              href={GENERAL_URLS.staking}
              className="font-medium text-primary-700 underline"
            >
              {GENERAL_URLS.staking}
            </ExternalLink>{' '}
            to receive SQRp instantly.
          </span>
        ),
      },
      {
        id: 'option2',
        subItem: (
          <span className="font-semibold">
            Option 2: Receive guaranteed SQRp monthly through Magic Square Membership at different
            levels.
          </span>
        ),
      },
    ],
  },
  {
    id: 'pool-size',
    item: (
      <span className="font-normal">
        Pool Size: <span className="font-semibold">$5,000 USDT</span>
      </span>
    ),
  },
  {
    id: 'contributions',
    item: (
      <span className="font-normal">
        Allocation Size:{' '}
        <span className="font-semibold">Contributions of $5 to $10 USDT are accepted.</span>
      </span>
    ),
  },
];

export const guaranteedRewards = [
  {
    id: 'prepare',
    item: (
      <span className="font-normal">
        Prepare for Future IDOs:{' '}
        <span className="font-semibold">
          Ensure your account is verified with KYC and that your funds are ready to fully engage in
          this and future launches.
        </span>
      </span>
    ),
  },
  {
    id: 'explore',
    item: (
      <span className="font-normal">
        Explore All Pools:{' '}
        <span className="font-semibold">
          We encourage you to experience each pool to maximize your understanding and utility of our
          platform.
        </span>
      </span>
    ),
  },
  {
    id: 'provide',
    item: (
      <span className="font-normal">
        Provide Valuable Feedback:{' '}
        <span className="font-semibold">
          After participating, you will be invited to share your insights via email, helping us
          refine and enhance the platform.
        </span>
      </span>
    ),
  },
  {
    id: 'cost-free',
    item: (
      <span className="font-normal">
        Cost-Free Participation:{' '}
        <span className="font-semibold">
          {' '}
          Engaging in this IDO incurs no fees, and you&apos;ll enjoy benefits such as KARMA points, SQRp,
          and the chance to buy discounted SQR tokens.
        </span>
      </span>
    ),
  },
];
